import PostListPage from '~components/post-list-page'

export default PostListPage({
  path: '/investor/:investor',
  title: 'Perfiles organización',
  sort: '-karma'
})



// WEBPACK FOOTER //
// ../frontend/pages/post/list-investor.js